export default __webpack_public_path__ + "static/media/tooltipIcon.9ddf6077.svg";